import { render, staticRenderFns } from "./hisWorks.vue?vue&type=template&id=4ab2b968"
import script from "./hisWorks.vue?vue&type=script&lang=js"
export * from "./hisWorks.vue?vue&type=script&lang=js"
import style0 from "./hisWorks.vue?vue&type=style&index=0&id=4ab2b968&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ab2b968')) {
      api.createRecord('4ab2b968', component.options)
    } else {
      api.reload('4ab2b968', component.options)
    }
    module.hot.accept("./hisWorks.vue?vue&type=template&id=4ab2b968", function () {
      api.rerender('4ab2b968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/teacherMatch/hisWorks.vue"
export default component.exports